export default __webpack_public_path__ + "static/media/19-LineMusic-Green.13f8633b.png";